import { createRouter, createWebHistory } from 'vue-router'


import Home from '../views/HomePage.vue'
import Tasks from '../views/Tasks.vue'
import HistoryTasks from '../views/HistoryTasks.vue'
import Login from '../views/LoginPage.vue'
import Account from '../views/Account.vue'
import Register from '../views/Register.vue'
import Document from '../views/Document.vue' 

import store from '../store/index.js'
import { API_GetMe } from '@/apiCalls/api'


/**
 * Define views to access from SideBar component
 */

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            component: Home
        },
        {
            path: '/tasks',
            component: Tasks
        },
        {
            path: '/historytasks',
            component: HistoryTasks
        },
        {
            path: '/login',
            component: Login
        },
        {
            path: '/account',
            component: Account
        },
        {
            path: '/register',
            component: Register
        },
        {
            path: '/reset',
            component: Register
        }, 
        { 
            path: '/documents', 
            component: Document 
        } 
    ]
});


router.beforeEach(async(to, from, next) => {
    if (!window.siteConfig) {
        const response = await fetch(process.env.BASE_URL + 'config.json')
        const config = await response.json()
        window.siteConfig = config
      }
    /**
     * Might be some issue with logic here but we check against the api
     * trying to find current user and then check if we still have
     */
     
    const isAuthenticated = localStorage.getItem('token');
    if(isAuthenticated){
        var now = new Date();
        var ticks = ((now.getTime() * 10000) + 621355968000000000);
        if(!localStorage.getItem('tokenExpiryDateInTicks') || parseInt(localStorage.getItem('tokenExpiryDateInTicks')) < ticks){
            location.reload();
            localStorage.clear('token');
            localStorage.clear('tokenExpiryDateInTicks');
        }
        store.dispatch('login/startCounterOnRefresh')
        const response = API_GetMe()
        response.then((res) => {
            localStorage.setItem('me', JSON.stringify(res.data))
            store.commit('account/setMe', res.data) 
            var chosenCustomerId = localStorage.getItem('chosenCustomer') 
            if(chosenCustomerId != null) 
                store.dispatch('account/setChosenCustomer', chosenCustomerId) 
            else if(res.data.Customers.length > 0){ 
                store.dispatch('account/setChosenCustomer', res.data.Customers[0].Id) 
            } 
            
        }).catch((e) => {
            console.log(e)
            if (isAuthenticated) {
                //location.reload();
                //next('login') //Should maybe use this instead?
            }
            localStorage.clear('token');
        });
        
    }


    //Define public pages
    const publicPages = ['/login', '/register', '/reset'];
    //Check if we require authentication on page we try to access (to.path) 
    const authRequired = !publicPages.includes(to.path);

    if (authRequired && !isAuthenticated) {
        //Authentication check failed reroute to login
        next('login')
    }
    else if (isAuthenticated && to.path == '/reset'){
        localStorage.clear('token');
        location.reload();
    }
    else if (isAuthenticated && to.path == '/login')
        //Authentication if trying to access login page while loged in, reroute to home ('')
        next('')
    else {
        //Allow page we try to access!
        next()
    }
});


export default router